import type { StateInfo } from "./types";

/**
 * 50 states + DC with their FIPS codes (us-atlas ids and persona
 * `state_code`s) and the certified 2024 presidential result: Trump and
 * Harris as percent of the total vote, and total ballots for president.
 * Source: FEC official 2024 results (state-certified), checked against
 * Wikipedia's results-by-state table; totals include write-ins.
 */
export const STATES: StateInfo[] = [
  {
    abbr: "AL",
    fips: "01",
    name: "Alabama",
    pres2024: { harris: 34.1, total: 2265090, trump: 64.6 },
  },
  {
    abbr: "AK",
    fips: "02",
    name: "Alaska",
    pres2024: { harris: 41.4, total: 338177, trump: 54.5 },
  },
  {
    abbr: "AZ",
    fips: "04",
    name: "Arizona",
    pres2024: { harris: 46.7, total: 3390161, trump: 52.2 },
  },
  {
    abbr: "AR",
    fips: "05",
    name: "Arkansas",
    pres2024: { harris: 33.6, total: 1182676, trump: 64.2 },
  },
  {
    abbr: "CA",
    fips: "06",
    name: "California",
    pres2024: { harris: 58.5, total: 15865475, trump: 38.3 },
  },
  {
    abbr: "CO",
    fips: "08",
    name: "Colorado",
    pres2024: { harris: 54.1, total: 3192745, trump: 43.1 },
  },
  {
    abbr: "CT",
    fips: "09",
    name: "Connecticut",
    pres2024: { harris: 56.4, total: 1759010, trump: 41.9 },
  },
  {
    abbr: "DE",
    fips: "10",
    name: "Delaware",
    pres2024: { harris: 56.5, total: 512912, trump: 41.8 },
  },
  {
    abbr: "DC",
    fips: "11",
    name: "District of Columbia",
    pres2024: { harris: 90.3, total: 325869, trump: 6.5 },
  },
  {
    abbr: "FL",
    fips: "12",
    name: "Florida",
    pres2024: { harris: 43.0, total: 10893752, trump: 56.1 },
  },
  {
    abbr: "GA",
    fips: "13",
    name: "Georgia",
    pres2024: { harris: 48.5, total: 5250905, trump: 50.7 },
  },
  {
    abbr: "HI",
    fips: "15",
    name: "Hawaii",
    pres2024: { harris: 60.6, total: 516701, trump: 37.5 },
  },
  {
    abbr: "ID",
    fips: "16",
    name: "Idaho",
    pres2024: { harris: 30.4, total: 905057, trump: 66.9 },
  },
  {
    abbr: "IL",
    fips: "17",
    name: "Illinois",
    pres2024: { harris: 54.4, total: 5633310, trump: 43.5 },
  },
  {
    abbr: "IN",
    fips: "18",
    name: "Indiana",
    pres2024: { harris: 39.6, total: 2936677, trump: 58.6 },
  },
  {
    abbr: "IA",
    fips: "19",
    name: "Iowa",
    pres2024: { harris: 42.5, total: 1663506, trump: 55.7 },
  },
  {
    abbr: "KS",
    fips: "20",
    name: "Kansas",
    pres2024: { harris: 41.0, total: 1327591, trump: 57.2 },
  },
  {
    abbr: "KY",
    fips: "21",
    name: "Kentucky",
    pres2024: { harris: 33.9, total: 2074530, trump: 64.5 },
  },
  {
    abbr: "LA",
    fips: "22",
    name: "Louisiana",
    pres2024: { harris: 38.2, total: 2006975, trump: 60.2 },
  },
  {
    abbr: "ME",
    fips: "23",
    name: "Maine",
    pres2024: { harris: 52.4, total: 831375, trump: 45.5 },
  },
  {
    abbr: "MD",
    fips: "24",
    name: "Maryland",
    pres2024: { harris: 62.6, total: 3038334, trump: 34.1 },
  },
  {
    abbr: "MA",
    fips: "25",
    name: "Massachusetts",
    pres2024: { harris: 61.2, total: 3473668, trump: 36.0 },
  },
  {
    abbr: "MI",
    fips: "26",
    name: "Michigan",
    pres2024: { harris: 48.3, total: 5664186, trump: 49.7 },
  },
  {
    abbr: "MN",
    fips: "27",
    name: "Minnesota",
    pres2024: { harris: 50.9, total: 3253920, trump: 46.7 },
  },
  {
    abbr: "MS",
    fips: "28",
    name: "Mississippi",
    pres2024: { harris: 38.0, total: 1228008, trump: 60.9 },
  },
  {
    abbr: "MO",
    fips: "29",
    name: "Missouri",
    pres2024: { harris: 40.1, total: 2995327, trump: 58.5 },
  },
  {
    abbr: "MT",
    fips: "30",
    name: "Montana",
    pres2024: { harris: 38.5, total: 602990, trump: 58.4 },
  },
  {
    abbr: "NE",
    fips: "31",
    name: "Nebraska",
    pres2024: { harris: 38.9, total: 952182, trump: 59.3 },
  },
  {
    abbr: "NV",
    fips: "32",
    name: "Nevada",
    pres2024: { harris: 47.5, total: 1484840, trump: 50.6 },
  },
  {
    abbr: "NH",
    fips: "33",
    name: "New Hampshire",
    pres2024: { harris: 50.7, total: 826189, trump: 47.9 },
  },
  {
    abbr: "NJ",
    fips: "34",
    name: "New Jersey",
    pres2024: { harris: 52.0, total: 4272725, trump: 46.1 },
  },
  {
    abbr: "NM",
    fips: "35",
    name: "New Mexico",
    pres2024: { harris: 51.9, total: 923403, trump: 45.9 },
  },
  {
    abbr: "NY",
    fips: "36",
    name: "New York",
    pres2024: { harris: 55.9, total: 8262495, trump: 43.3 },
  },
  {
    abbr: "NC",
    fips: "37",
    name: "North Carolina",
    pres2024: { harris: 47.6, total: 5699141, trump: 50.9 },
  },
  {
    abbr: "ND",
    fips: "38",
    name: "North Dakota",
    pres2024: { harris: 30.5, total: 368155, trump: 67.0 },
  },
  {
    abbr: "OH",
    fips: "39",
    name: "Ohio",
    pres2024: { harris: 43.9, total: 5767788, trump: 55.1 },
  },
  {
    abbr: "OK",
    fips: "40",
    name: "Oklahoma",
    pres2024: { harris: 31.9, total: 1566173, trump: 66.2 },
  },
  {
    abbr: "OR",
    fips: "41",
    name: "Oregon",
    pres2024: { harris: 55.3, total: 2244493, trump: 41.0 },
  },
  {
    abbr: "PA",
    fips: "42",
    name: "Pennsylvania",
    pres2024: { harris: 48.5, total: 7058732, trump: 50.2 },
  },
  {
    abbr: "RI",
    fips: "44",
    name: "Rhode Island",
    pres2024: { harris: 55.5, total: 513386, trump: 41.8 },
  },
  {
    abbr: "SC",
    fips: "45",
    name: "South Carolina",
    pres2024: { harris: 40.4, total: 2548140, trump: 58.2 },
  },
  {
    abbr: "SD",
    fips: "46",
    name: "South Dakota",
    pres2024: { harris: 34.2, total: 428922, trump: 63.4 },
  },
  {
    abbr: "TN",
    fips: "47",
    name: "Tennessee",
    pres2024: { harris: 34.5, total: 3063942, trump: 64.2 },
  },
  {
    abbr: "TX",
    fips: "48",
    name: "Texas",
    pres2024: { harris: 42.5, total: 11388674, trump: 56.1 },
  },
  {
    abbr: "UT",
    fips: "49",
    name: "Utah",
    pres2024: { harris: 37.8, total: 1488494, trump: 59.4 },
  },
  {
    abbr: "VT",
    fips: "50",
    name: "Vermont",
    pres2024: { harris: 63.8, total: 369422, trump: 32.3 },
  },
  {
    abbr: "VA",
    fips: "51",
    name: "Virginia",
    pres2024: { harris: 51.8, total: 4505941, trump: 46.1 },
  },
  {
    abbr: "WA",
    fips: "53",
    name: "Washington",
    pres2024: { harris: 57.2, total: 3924243, trump: 39.0 },
  },
  {
    abbr: "WV",
    fips: "54",
    name: "West Virginia",
    pres2024: { harris: 28.1, total: 762582, trump: 70.0 },
  },
  {
    abbr: "WI",
    fips: "55",
    name: "Wisconsin",
    pres2024: { harris: 48.7, total: 3422918, trump: 49.6 },
  },
  {
    abbr: "WY",
    fips: "56",
    name: "Wyoming",
    pres2024: { harris: 25.8, total: 269048, trump: 71.6 },
  },
];
